import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
    selector: "[pcg-ng-date-filter]",
    templateUrl: "./date-filter.component.html",
    providers: []
})
export class DateFilterComponent  {

    public fromDateControl: FormControl<string> = null;
    @Input("fromDate")
    public set fromDateSetter(value: FormControl<string>){
        this.fromDateControl = value;
    }

    public toDateControl: FormControl<string> = null;
    @Input("toDate")
    public set toDateSetter(value: FormControl<string>){
        this.toDateControl = value;
    }

    @Output()
    public onSubmit = new EventEmitter();

    public submit(): void {
        this.onSubmit.emit();
    }
}
